import { render } from "./otp.vue?vue&type=template&id=0d13452b&scoped=true"
import script from "./otp.vue?vue&type=script&lang=js"
export * from "./otp.vue?vue&type=script&lang=js"

import "./otp.vue?vue&type=style&index=0&id=0d13452b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d13452b"]])

export default __exports__